import type { DocumentCategory, DocumentReviewStatus } from '../../../../mocks/cases';

interface Props {
  title: string;
  category: DocumentCategory;
  status: DocumentReviewStatus;
  onChange: (status: DocumentReviewStatus) => void;
}

export default function CategoryHeader({ title }: Props) {
  return (
    <div className="mb-5">
      <h2 className="text-xl font-semibold text-slate-900 leading-tight">{title}</h2>
    </div>
  );
}

